import { useParams } from 'react-router-dom';

import { useGetParkingSpotsByIdQuery } from '@client/api';

import { ParkingSpotInformationCard } from '../components/parking-spot-information-card.component';
import { SpaceAreaHistoryCard } from '../components/space-area-history/space-area-history-card.component';

export const ParkingSpotView = () => {
  const { spaceId } = useParams<{ spaceId: string }>();

  const { data: space, isFetching } = useGetParkingSpotsByIdQuery(
    {
      id: spaceId ?? '',
    },
    { skip: !spaceId },
  );

  return (
    <div className="relative md:flex">
      <div className="w-full mb-2 space-y-2">
        <ParkingSpotInformationCard space={space} isFetching={isFetching} />

        <SpaceAreaHistoryCard spaceId={spaceId} />
      </div>
    </div>
  );
};
